import {createSelector, chain} from 'helpers';
import {RootState} from 'store/root-state.type';

export const examples = createSelector(
  (state: RootState) => state.goals.templates,
  (templates) => chain(templates)
    .filter(example => Boolean(example.type))
    .groupBy(example => example.type.replace(/[0-9 ]/gi, ''))
    .value()
);
